/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('SmsCampaign_Resource', ["$resource", "$location",
    function ($resource, $location) {
        var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
        return $resource(baseUrl + 'rest/smsCampaigns/:id', {}, {
            query: {method: 'GET', isArray: true},
            get: {method: 'GET'},
            getSms: {method: 'GET', isArray: true, url: baseUrl + 'rest/smsCampaigns/getSms/:id'}
        });
    }
]);

angular.module('FlexyBeautyApp.services').factory('SmsCampaign', ["SmsCampaign_Resource", "SmsCampaignData", "CustomerData",
    function (SmsCampaign_Resource, SmsCampaignData, CustomerData) {
        var SmsCampaign = function (resource) {
            // Call the parent constructor
            this.id = null;
            this.isDeleted = false;
            this.label = null;
            this.subject = null;
            this.text = null;
            this.establishment = "";
            this.type = null;
            this.autoType = null;
            this.autoNb = null;
            this.sendingDate = null;
            this.status = null;
            this.customers = [];
            this.filters = [];
            this.version = null;
            if (resource !== undefined && resource != null)
                this.loadObject(resource);

            SmsCampaignData.add(this);
        }
        SmsCampaign.prototype.initUsingDefaults = function () {
            this.type = 'campaign';
            this.autoType = 'birthday';
            this.autoNb = 30;
            this.status = "created";
        }
        SmsCampaign.prototype.loadObject = function (object) {
            if (!this.id)
                this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.label = object.label;
            this.subject = object.subject;
            this.text = object.text;
            this.establishment = object.establishment;
            this.type = object.type;
            this.autoType = object.autoType;
            this.autoNb = object.autoNb;
            if (object.sendingDate)
                this.sendingDate = new Date(object.sendingDate);
            this.status = object.status;
            this.customersId = object.customersId;
            if (object.filters) {
                for (var i = 0; i < object.filters.length; i++) {
                    this.filters.push({
                        code: object.filters[i].code,
                        value: object.filters[i].value,
                        selectedItemViews: object.filters[i].selectedItemViews
                    });
                }
            }
            if (object.version) {
                this.version = object.version;
            }
        }
        SmsCampaign.prototype.loadRef = function (isApplicationLoading) {
            //load ref from ids
            if (this.customersId) {
                var newCustomers = [];
                for (var i = 0; i < this.customersId.length; i++) {
                    var customer = CustomerData.getById(this.customersId[i], isApplicationLoading);
                    if (customer != null)
                        newCustomers.push(customer);
                }
                this.customers = newCustomers;
            }

            delete this.customersId;
        }

        SmsCampaign.prototype.getObjectResource = function () {
            var rsSmsCampaign = new SmsCampaign_Resource();
            rsSmsCampaign.id = this.id;
            rsSmsCampaign.isDeleted = this.isDeleted;
            rsSmsCampaign.label = this.label;
            rsSmsCampaign.subject = this.subject;
            rsSmsCampaign.text = this.text;
            rsSmsCampaign.establishment = this.establishment;
            rsSmsCampaign.type = this.type;
            rsSmsCampaign.autoType = this.autoType;
            rsSmsCampaign.autoNb = this.autoNb;
            if (this.sendingDate) {
                rsSmsCampaign.sendingDate = new Date(this.sendingDate);
            }
            rsSmsCampaign.status = this.status;
            rsSmsCampaign.customersId = [];

            for (var i = 0; i < this.customers.length; i++) {
                rsSmsCampaign.customersId.push(this.customers[i].id);
            }
            rsSmsCampaign.filters = [];
            if (this.filters) {
                for (var i = 0; i < this.filters.length; i++) {
                    rsSmsCampaign.filters.push({
                        code: this.filters[i].code,
                        value: this.filters[i].value,
                        selectedItemViews: this.filters[i].selectedItemViews
                    });
                }
            }
            return rsSmsCampaign;
        }

        SmsCampaign.prototype.copyToObject = function (object) {
            object.id = this.id
            object.label = this.label
        }

        SmsCampaign.prototype.getId = function () {
            return this.id;
        }

        SmsCampaign.prototype.setId = function (id) {
            this.id = id;
        }

        return SmsCampaign;
    }
]);

angular.module('FlexyBeautyApp.services').factory('SmsCampaignSrv', ["$log", "SmsCampaign_Resource", "SmsCampaign", "SmsCampaignData", "UserActionData", "ServerSrv",
    function ($log, SmsCampaign_Resource, SmsCampaign, SmsCampaignData, UserActionData, ServerSrv) {
        var smsCampaignSrv = {};

        smsCampaignSrv.query = function (successFunction, errorFunction) {

            SmsCampaign_Resource.query(
                {}, //params
                function (data) {   //success
                    SmsCampaignData.clear();

                    for (var i = 0; i < data.length; i++) {
                        new SmsCampaign(data[i]);//auto register to DATA
                    }

                    if (successFunction !== undefined)
                        successFunction(SmsCampaignData.getActiveList());
                },
                function (data) {
                    $log.error(data);
                    if (errorFunction !== undefined)
                        errorFunction(data);
                });
        }
        smsCampaignSrv.getSms = function (smsCampaign, successFunction, errorFunction) {
            if (smsCampaign) {
                SmsCampaign_Resource.getSms(
                    {id: smsCampaign.id}, //params
                    function (data) {
                        if (successFunction !== undefined)
                            successFunction(data);
                    },
                    function (data) {
                        $log.error(data);
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    });
            } else if (errorFunction !== undefined)
                errorFunction();
        }

        smsCampaignSrv.restore = function (smsCampaign, successFunction, errorFunction) {
            SmsCampaignData.restore(smsCampaign);
            ServerSrv.startSavingProcess(smsCampaignSrv.restoreSync, smsCampaign, successFunction, errorFunction);
        };
        smsCampaignSrv.restoreSync = function (smsCampaign, successFunction, errorFunction) {
            //$timeout (function () {

            var smsCampaignRes = smsCampaign.getObjectResource();
            smsCampaignRes.$save({}, //no params
                function (data) {
                    try {
                        smsCampaign.setId(data.id);
                        if (!smsCampaign.version || (data.version && data.version > smsCampaign.version))
                            smsCampaign.version = data.version;
                        UserActionData.add(data.userAction);
                        if (successFunction != undefined)
                            successFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );

            //},2000)
        }
        smsCampaignSrv.save = function (smsCampaign, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(smsCampaignSrv.saveSync, smsCampaign, successFunction, errorFunction);
        };
        smsCampaignSrv.saveSync = function (smsCampaign, successFunction, errorFunction) {
            //$timeout (function () {

            var smsCampaignRes = smsCampaign.getObjectResource();
            smsCampaignRes.$save({}, //no params
                function (data) {
                    try {
                        smsCampaign.setId(data.id);
                        UserActionData.add(data.userAction);
                        if (successFunction != undefined)
                            successFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );

            //},2000)
        }
        smsCampaignSrv.remove = function (smsCampaign, successFunction, errorFunction) {
            SmsCampaignData.remove(smsCampaign);
            ServerSrv.startSavingProcess(smsCampaignSrv.removeSync, smsCampaign, successFunction, errorFunction);
        };
        smsCampaignSrv.removeSync = function (smsCampaign, successFunction, errorFunction) {
            var smsCampaignSrv = new SmsCampaign_Resource();
            smsCampaignSrv.$remove({id: smsCampaign.getId()}, //params : id
                function (data) {
                    try {
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction != undefined)
                            successFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );

            //},2000)
        }
        smsCampaignSrv.updateLocally = function (id, objectToRestore) {
            var smsCampaign = SmsCampaignData.getById(id)
            if (smsCampaign != null) {
                smsCampaign.loadObject(objectToRestore);
                smsCampaign.loadRef();
            }
            return smsCampaign;
        }
        smsCampaignSrv.removeLocally = function (id, object) {
            var smsCampaign = SmsCampaignData.getById(id)
            if (smsCampaign != null) {
                SmsCampaignData.remove(smsCampaign);
            }
            return smsCampaign;
        }
        smsCampaignSrv.addLocally = function (id, objectToRestore) {
            var smsCampaign = SmsCampaignData.getById(id)
            if (smsCampaign != null) {
                smsCampaign.loadObject(objectToRestore);
                smsCampaign.loadRef();
                SmsCampaignData.add(smsCampaign);
            }
            return smsCampaign;
        }
        smsCampaignSrv.loadRef = function (isApplicationLoading) {
            var smsCampaigns = SmsCampaignData.getActiveList();
            for (var i = 0; i < smsCampaigns.length; i++)
                smsCampaigns[i].loadRef(isApplicationLoading);
        }

        return smsCampaignSrv;
    }
]);

angular.module('FlexyBeautyApp.services').factory('SmsCampaignData', ["$log", function ($log) {
    var smsCampaignDataSrv =
        {
            indexSmsCampaigns: [], //Never deleted (used as index)
            activeSmsCampaigns: [],//active list
            deletedSmsCampaigns: []//deleted items
        };
    smsCampaignDataSrv.getById = function (smsCampaignId) {
        for (var i = 0; i < this.indexSmsCampaigns.length; i++)
            if (this.indexSmsCampaigns[i].id == smsCampaignId)
                return this.indexSmsCampaigns[i];
        return null;
    }
    smsCampaignDataSrv.getIndexOf = function (smsCampaign) {
        if (smsCampaign)
            return this.indexSmsCampaigns.indexOf(smsCampaign);
        return -1;
    }
    smsCampaignDataSrv.getByIndex = function (smsCampaignIndex) {
        if (smsCampaignIndex >= 0 && smsCampaignIndex < this.indexSmsCampaigns.length)
            return this.indexSmsCampaigns[smsCampaignIndex];
        else
            return null;
    }
    smsCampaignDataSrv.add = function (smsCampaign) {
        var smsCampaignArray = this.activeSmsCampaigns;
        if (smsCampaign.isDeleted)
            smsCampaignArray = this.deletedSmsCampaigns;
        var index = this.indexSmsCampaigns.indexOf(smsCampaign);
        if (index != -1) {
            var realIndex = smsCampaignArray.indexOf(smsCampaign);
            if (realIndex == -1)
                smsCampaignArray.push(smsCampaign);
        } else {
            index = this.indexSmsCampaigns.length;
            this.indexSmsCampaigns.push(smsCampaign);
            smsCampaignArray.push(smsCampaign);
        }
        return index;
    }
    smsCampaignDataSrv.remove = function (smsCampaign) //Soft Remove
    {
        var index = this.activeSmsCampaigns.indexOf(smsCampaign);
        if (index != -1) {
            this.activeSmsCampaigns.splice(index, 1);
            this.deletedSmsCampaigns.push(smsCampaign)
            smsCampaign.isDeleted = true;
        }

    }
    smsCampaignDataSrv.restore = function (smsCampaign) //Soft Remove
    {
        var index = this.deletedSmsCampaigns.indexOf(smsCampaign);
        if (index != -1) {
            this.deletedSmsCampaigns.splice(index, 1);
            this.activeSmsCampaigns.push(smsCampaign)
            smsCampaign.isDeleted = false;
        }

    }
    smsCampaignDataSrv.clear = function () {
        this.indexSmsCampaigns = [];
        this.activeSmsCampaigns = [];
        this.deletedSmsCampaigns = [];
    }
    smsCampaignDataSrv.getActiveList = function () {
        return this.activeSmsCampaigns;
    }
    smsCampaignDataSrv.getDeletedList = function () {
        return this.deletedSmsCampaigns;
    }

    return smsCampaignDataSrv;
}
]);



// WEBPACK FOOTER //
// ./js/services/models/SmsCampaign.js